import { booleanAttribute, Component, input, OnInit, output, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent } from 'src/app/components/card/card.component';
import { EmailFormComponent } from "src/app/components/email-form/email-form.component";

@Component({
  selector: 'app-email-card',
  standalone: true,
  imports: [
    TranslateModule,
    CardComponent,
    EmailFormComponent
],
  templateUrl: './email-card.component.html'
})
export class EmailCardComponent implements OnInit {
  @ViewChild('cardComponent') cardComponent!: CardComponent;

  index = input<number>();
  totalItems = input<number>();
  control = input.required<any>();
  remove = output<void>();

  disabled = input(false, { transform: booleanAttribute });

  ngOnInit(): void {
    if (this.disabled()) {
      this.control().disable();
    }
  }

  isFormInvalid(): void {
    if (this.control().invalid && this.cardComponent) {
      this.cardComponent.isOpen.set(true);
    }
  }
}
